import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import { CheckCircle2, X } from "lucide-react";

export default function GetInfoDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", interest: "general" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", form);
      setSubmitted(true);
      toast.success("Info pack on the way. Check your inbox.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const close = () => {
    onOpenChange(false);
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: "", email: "", phone: "", interest: "general" });
    }, 300);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="getinfo-dialog"
        className="bg-[#f7f7f7] border border-black/15 text-[#0a0a0a] max-w-lg p-0 rounded-none"
      >
        {!submitted ? (
          <form onSubmit={submit} className="p-10">
            <DialogHeader className="mb-8">
              <div className="overline">Get the info pack</div>
              <DialogTitle className="font-display text-3xl font-light tracking-tight text-[#0a0a0a] mt-2">
                See if Sold By 1st Choice is right for you.
              </DialogTitle>
              <DialogDescription className="text-black/60 mt-2">
                We'll email a private brief with comp splits, software list, and how to apply.
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-6">
              <div>
                <label className="field-label">Full name</label>
                <input
                  required
                  className="input-line"
                  data-testid="getinfo-name"
                  value={form.name}
                  onChange={update("name")}
                />
              </div>
              <div>
                <label className="field-label">Email</label>
                <input
                  required
                  type="email"
                  className="input-line"
                  data-testid="getinfo-email"
                  value={form.email}
                  onChange={update("email")}
                />
              </div>
              <div>
                <label className="field-label">Phone (optional)</label>
                <input
                  className="input-line"
                  data-testid="getinfo-phone"
                  value={form.phone}
                  onChange={update("phone")}
                />
              </div>
              <div>
                <label className="field-label">I'm interested in</label>
                <select
                  className="input-line"
                  data-testid="getinfo-interest"
                  value={form.interest}
                  onChange={update("interest")}
                >
                  <option value="general" className="bg-white text-black">General info</option>
                  <option value="solo-agent" className="bg-white text-black">Joining as a solo agent</option>
                  <option value="team-move" className="bg-white text-black">Moving my team</option>
                  <option value="brokerage-owner" className="bg-white text-black">Brokerage merger</option>
                </select>
              </div>
            </div>

            <button
              type="submit"
              disabled={submitting}
              data-testid="getinfo-submit"
              className="btn-primary w-full mt-10 disabled:opacity-50"
            >
              {submitting ? "Sending..." : "Send my info pack"}
            </button>
          </form>
        ) : (
          <div className="p-12 text-center">
            <CheckCircle2 className="text-[#121275] mx-auto mb-6" size={48} strokeWidth={1.25} />
            <div className="overline">Received</div>
            <h3 className="font-display text-2xl mt-2 text-[#0a0a0a] font-light">
              We've got your info.
            </h3>
            <p className="text-black/60 mt-3 max-w-sm mx-auto">
              A real human will reach out within one business day. Look out for an email from
              join@soldby1stchoice.com.
            </p>
            <button onClick={close} className="btn-secondary mt-8" data-testid="getinfo-close">
              Close
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
